import { loc } from './localization'

export default {
  install: app => {
    app.config.globalProperties.loc = loc
  }
}
